export enum ZIndex {
  AppLayoutBackButton = 10000,
  DevTools = 9999999,
  FluentProvider = 1000000000,
  PageLayoutHeader = 99999,
  PageLayoutBanner = 99999,
  PageLayoutFooter = 99999,
  PageLayoutSubHeader = 9999,
  PageLayoutContentTopBar = 9999,
  PageLayoutCollapsiblePanel = 9999,
  PageLayoutContentColumn = 999,
  SingleColumnLayoutHeader = 99999,
  SingleColumnLayoutBanner = 9999,
  SingleColumnLayoutFooter = 9999,
}
